import { lazy } from 'react';
import Loadable from '../../components/Loadable';

const Consoliddate = Loadable(lazy(() => import('./Consoliddate')));

const ConsoliddateRoutes = [{ path: '/cewb', element: <Consoliddate /> }];

export default ConsoliddateRoutes;
